import moment from 'moment';

/**
 * @module Utils/FormatTime
 * @description This file contains functions to handle time objects
 * 
 */


/**
 * @function
 * @description The function takes a date input, checks if it's valid using moment.js library, and returns the date
 * in 'YYYY-MM-DD' format if valid.
 * @param data - A date string in any format that can be parsed by the moment library.
 * @returns The function `onGetDate` returns a string in the format 'YYYY-MM-DD' if the input `data` is
 * a valid date, otherwise it returns `null`.
 */
export const onGetDate = (data) => {
  let response = null
  const temp = moment(data)
  if(temp.isValid){
    response = temp.format('YYYY-MM-DD')
  }
  return response
}
